import autoSetAge from './autoSetAge';
import initPublicationThumbnails from './publicationThumbnails';

autoSetAge();
initPublicationThumbnails();
